import React from 'react'
import HeaderForSyllabus from '../../Components/HeaderForSyllabus/HeaderForSyllabus'
import Trainings from '../../Components/Tranings/Tranings'

const SyllabusPage = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%',          // ← 100vh deyil, 100% — valideyndən alsın
      overflow: 'hidden',
      background: '#f3f4f6',
      boxSizing: 'border-box',
    }}>
      <HeaderForSyllabus/>
      <Trainings/>
    </div>
  )
}

export default SyllabusPage